<template>
  <div style="background-color: #F1F4FB;">
    <div class="px-4 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl sm:px-20 md:px-28 lg:px-10">
      <div class="py-5 test">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }" class="myColor">EMHUB</el-breadcrumb-item>
          <el-breadcrumb-item>新闻中心</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div>
        <div class="container">
          <!-- 内容 -->
          <div class="container mx-auto py-10">
            <div class="flex flex-wrap md:flex-nowrap py-5 border-b cursor-pointer" @click="toNewsContent(item.id)"
              style="border-color: rgba(151,151,151,0.4)" v-for="(item,index) in newsList" :key="index">
              <div class="flex-shrink-0 flex flex-col">
                <img :src="item.img" class="newsImg" style="width: 200px;height: 130px;" alt="">
              </div>
              <div class="relative md:flex-grow">
                <div class="block item pl-5">
                  <div class="font-semibold text-base mb-3 newsTitle">
                    {{item.title}}
                  </div>
                  <div class="text-gray-400 text-sm tracking-wider newsIntroduceClass">
                    {{item.introduce}}
                  </div>
                  <div class="text-gray-400 text-sm tracking-wider absolute bottom-0">
                    {{item.data}}
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import {
baseOSSUrl
} from '@/utils/oss'
  export default {
    name: "newsListContent",
    data() {
      return {
        newsList: [{
            id: 5,
            img: baseOSSUrl + '/newsCount5-1.png',
            title: "欧洲医疗服务中心与第十一届盘古大血管疾病论坛合作圆满成功",
            introduce: "欧洲医疗服务中心与第十一届盘古大血管疾病论坛合作圆满成功",
            data: "2022年6月20日 10:00",
          },
          {
            id: 1,
            img: baseOSSUrl + '/newsCount1-1.png',
            title: "中欧专家远程连线，共话心血管诊疗",
            introduce: "中欧专家远程连线，共话心血管诊疗",
            data: "2022年4月6日 16:00",
          }, {
            id: 2,
            img: baseOSSUrl + '/doctor1.png',
            title: "中欧国际心血管教育和交流项目顺利召开",
            introduce: "中欧国际心血管教育和交流项目顺利召开",
            data: "2022年3月2日 17:00",
          },
          {
            id: 3,
            img: baseOSSUrl + '/ag2.png',
            title: "蔡奇书记一行走访调研银山集团孵化企业-瑷格干细胞",
            introduce: "蔡奇书记一行走访调研银山集团孵化企业-瑷格干细胞",
            data: "2021年11月29日 上午",
          }, {
            id: 4,
            img: baseOSSUrl + '/ag.png',
            title: "瑷格干细胞研发中心启动仪式成功举行",
            introduce: "瑷格干细胞研发中心启动仪式成功举行",
            data: "2021年10月16日 上午",
          },
        ]
      }
    },
    methods: {
      toNewsContent(item) {
        this.$router.push({
          path: '/newsContent',
          query: {
            newsIndex: item
          }
        })
      }
    },
  }
</script>

<style scoped>
  /*#123B7F*/

  .myColor /deep/ .el-breadcrumb__inner {
    color: #123B7F;
  }

  .myColor>>>.el-breadcrumb__inner:hover {
    color: #123B7F;
  }

  /* 超过3行文字就省略*/
  .newsIntroduceClass {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }

  .newsTitle {
    letter-spacing: 1px;
    color: #333333;
  }
</style>